import React from "react";
import {Button, Form, Input, message, Modal} from "antd";
import ManagerRepo from '../../repository/manager';

class EditManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
    }
  }

  close = () => {
    this.props.setVisible(false)
  }

  update = () => {
    const { business, manager } = this.props
    const form = this.props.form;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      this.setState({
        loading: true,
      });

      ManagerRepo.update(business.id, manager.id, values).then(
        result => {
          this.setState({loading: false});
          this.close();
          message.success('Manager was updated');
        },
        error => {
          console.log(error.response);
          message.error(error.response.data.message);
          this.setState({loading: false});
        },
      )
    })
  }

  revoke = () => {
    const { business, manager } = this.props
    ManagerRepo.revoke(business.id, manager.id).then(
      result => {
        this.setState({loading: false});
        this.close();
        message.success('Manager access was revoked');
      },
      error => {
        console.log(error.response);
        message.error(error.response.data.message);
        this.setState({loading: false});
      },
    )
  }

  unrevoke = () => {
    const { business, manager } = this.props
    ManagerRepo.unrevoke(business.id, manager.id).then(
      result => {
        this.setState({loading: false});
        this.close();
        message.success('Manager access was re-enabled');
      },
      error => {
        console.log(error.response);
        message.error(error.response.data.message);
        this.setState({loading: false});
      },
    )
  }

  render() {
    const { manager } = this.props;
    const {getFieldDecorator} = this.props.form;
    if (!manager) {
      return <></>
    }
    
    return (
      <Modal
        visible={this.props.visible || false}
        title="Editing manager"
        onOk={this.update}
        onCancel={this.close}
        footer={[
          <Button key="back" onClick={this.close}>
            Cancel
          </Button>,
          manager.disabled_at ? <Button key="enable" onClick={this.unrevoke}>Re-enable</Button>
            : <Button key="revoke" type="danger" onClick={this.revoke}>Revoke</Button>
          ,
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.update}>
            Update
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="ID">
            <span className="ant-input ant-input-disabled">{manager.id}</span>
          </Form.Item>
          <Form.Item label="E-mail">
            {getFieldDecorator('email', {
              initialValue: manager.email,
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="User ID (deprecated)">
            <span className="ant-input ant-input-disabled">{manager.user_id}</span>
          </Form.Item>
          <Form.Item label="Disabled at">
            <span className="ant-input ant-input-disabled">{manager.disabled_at}</span>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({name: 'edit_manager'})(EditManager);
